import '.je{margin-bottom:56px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.at{margin-bottom:24px;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.b2{gap:16px;}.ssr-plugin'
import { styled } from 'inlines'
import { Text } from '../../Text/index.js'
import { SchemaFormComponent } from '../SchemaFormComponent.js'
import { capitalize, splitByUppercase } from '../../../utils/text.js'

const RenderField: React.FC<{
  item: any
  value: any
  onChange: any
  name: any
  disabled: any
}> = ({ item, value, onChange, name, disabled }) => {
  if (item.hide) {
    return null
  }

  return (
    <SchemaFormComponent
      key={name}
      value={value}
      onChange={onChange}
      name={name}
      schemaProp={item}
      disabled={disabled}
    />
  )
}

export const ObjectType = ({
  value,
  onChange,
  schemaProp,
  name: objectName,
  disabled,
}) => {
  const { title, description, readOnly, props } = schemaProp

  // gather onChanges here>??
  const changes = (v, name) => {
    if (onChange) {
      onChange(
        (prevObj: any) => ({
          ...(prevObj || {}),
          [name]: v,
        }),
        objectName,
      )
    }
  }

  return (
    <div className="je">
      {(title || description) && (
        <div className="a at a3 i"
        >
          {title && (
            <Text variant="subheading-medium">
              {capitalize(splitByUppercase(title))}
            </Text>
          )}
          {description && (
            <Text variant="display-regular" color="neutral60">
              {description}
            </Text>
          )}
        </div>
      )}

      <div className="a i b2">
        {Object.keys(props)?.map((item) => {
          return (
            <RenderField
              key={item}
              item={props[item]}
              value={value?.[item]}
              onChange={changes}
              name={item}
              disabled={disabled || readOnly}
            />
          )
        })}
      </div>
    </div>
  )
}
